import { render } from "./TheVehiclesList.vue?vue&type=template&id=ea1277a0"
import script from "./TheVehiclesList.vue?vue&type=script&lang=js"
export * from "./TheVehiclesList.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__